import { useEffect } from "react";

const SITE_URL = "https://rvasigns.com";
const DEFAULT_TITLE = "RVA Signs — Independent Signage Guidance for Richmond Businesses";
const DEFAULT_DESC = "Independent signage guidance for Richmond businesses. Todd Friedman helps you navigate permits, landlord approvals, quotes, and timelines before you spend money on signs.";
const DEFAULT_IMAGE = "https://customer-assets.emergentagent.com/job_todd-signs-richmond/artifacts/v0nymp1d_Todd%20Professional%20Headshot.png";

function upsertMeta(attr, key, value) {
  if (!value) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
}

function upsertCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

/**
 * Seo — sets per-page <title>, meta description, canonical, OG/Twitter tags,
 * and optionally injects a JSON-LD script (cleaned up on unmount).
 */
export default function Seo({ title, description, path = "/", image, jsonLd }) {
  useEffect(() => {
    const fullTitle = title ? `${title} — RVA Signs` : DEFAULT_TITLE;
    const desc = description || DEFAULT_DESC;
    const url = `${SITE_URL}${path}`;
    const ogImage = image || DEFAULT_IMAGE;

    document.title = fullTitle;

    upsertMeta("name", "description", desc);
    upsertCanonical(url);

    upsertMeta("property", "og:title", fullTitle);
    upsertMeta("property", "og:description", desc);
    upsertMeta("property", "og:url", url);
    upsertMeta("property", "og:image", ogImage);

    upsertMeta("name", "twitter:title", fullTitle);
    upsertMeta("name", "twitter:description", desc);
    upsertMeta("name", "twitter:image", ogImage);

    let scriptEl = null;
    if (jsonLd) {
      scriptEl = document.createElement("script");
      scriptEl.type = "application/ld+json";
      scriptEl.setAttribute("data-seo-page", "true");
      scriptEl.text = JSON.stringify(jsonLd);
      document.head.appendChild(scriptEl);
    }

    return () => {
      if (scriptEl && scriptEl.parentNode) {
        scriptEl.parentNode.removeChild(scriptEl);
      }
    };
  }, [title, description, path, image, JSON.stringify(jsonLd)]);

  return null;
}
